import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import { authActions } from '@content-platform/web-angular-shared-util-auth';
import { GraphApi } from '../services';
import { getAdalId } from '../user-profile-helpers';
import { LoadCurrentUserSuccess } from '../actions/ad-user.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../services";
/**
 * The Graph Api effects imported in {@link GraphApiModule}.
 *
 * @export
 * @class GraphApiEffects
 */
export class GraphApiEffects {
    constructor(actions, api) {
        this.actions = actions;
        this.api = api;
        /**
         * Listens to the LOGIN_SUCCESS action to get the graph api token, this token takes a little longer so it's best
         * to retrieve it right after user login succeeds.
         */
        this.loginSuccess = createEffect(() => this.actions.pipe(ofType(authActions.LOGIN_SUCCESS), map((action) => action.payload), switchMap(adUser => adUser.profile?.permissionToken
            ? of(new LoadCurrentUserSuccess(adUser.profile))
            : this.api
                .getFullUserDetails(getAdalId(adUser))
                .pipe(map(user => new LoadCurrentUserSuccess(user))))));
    }
    static { this.ɵfac = function GraphApiEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GraphApiEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.GraphApi)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GraphApiEffects, factory: GraphApiEffects.ɵfac }); }
}
//# sourceMappingURL=graph-api.effects.js.map